import { createRouter, createWebHistory } from "vue-router";
import UserLogin from "@/views/UserLogin.vue";
import tools from "@/views/tools.vue";
import applications from "@/views/applications.vue";
import roles from "@/views/RolesView.vue";
import accounts from "@/views/accounts.vue";
import ViewTool from "@/views/ViewTool.vue";
import EditTool from "@/views/EditTool.vue";

const routes = [
  { path: "/login", name: "UserLogin", component: UserLogin },
  { path: "/tools", name: "tools", component: tools },
  { path: "/applications", name: "applications", component: applications },
  { path: "/:catchAll(.*)", redirect: "/login" }, // 捕獲所有未知路徑並重定向到 /login
  { path: "/users/roles", name: "Roles", component: roles },
  { path: "/users/accounts", name: "Accounts", component: accounts },
  {
    path: "/tool/view/:codeno", // 將參數名稱更改為 "codeno"
    name: "ViewTool",
    component: ViewTool,
  },
  {
    path: "/tool/edit/:codeno", // 編輯工具也使用 "codeno" 參數
    name: "EditTool",
    component: EditTool,
  },
  
  {
    path: "/add-tool",
    name: "AddTool",
    component: () => import("@/views/AddTool.vue"),
  },
];


const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes,
});

export default router;
